<template>
    <div>
          <vx-card
                    v-if="partisipants.length > 0"
                    :title="$t('participants')"
                    class="mt-6 lg:mt-base"
                >
                <!-- FRIENDS LIST -->
                <ul class="friend-suggesions-list">
                    <li
                        class="friend-suggestion flex items-center mb-4 justify-between"
                        v-for="(friend, index) in partisipants"
                        :key="index"
                    >
                        <profile
                            :avatar="friend.student_profile.avatar"
                            :subtitle="friend.membership_role.name"
                            :profile="friend.student_profile"
                            btnMessage
                        />
                        <div class="flex">
                            <vx-tooltip
                                :text="$t('remove_partisipant')"
                                position="left"
                                v-if="
                                    isFounder &&
                                    friend.membership_role.code !==
                                        'FOUNDER'
                                "
                            >
                                <vs-button
                                    class="ml-2 cursor-pointer block"
                                    @click="deleteStudent(friend)"
                                    radius
                                    type="border"
                                    size="small"
                                    icon-pack="feather"
                                    icon="icon-minus"
                                />
                            </vx-tooltip>
                            <vx-tooltip
                                :text="$t('change_moderator')"
                                position="bottom"
                                v-if="
                                    isFounder &&
                                    friend.membership_role.code !==
                                        'FOUNDER' &&
                                    friend.membership_role.code !== 'MODERATOR'
                                        
                                "
                            >
                                <div class="ml-2 cursor-pointer">
                                    <vs-button
                                        @click="toModerator(friend)"
                                        radius
                                        size="small"
                                        type="border"
                                        icon="person"
                                    />
                                </div>
                            </vx-tooltip>
                            <vx-tooltip
                                :text="$t('delete_moderator')"
                                position="bottom"
                                v-if="
                                    isFounder &&
                                    friend.membership_role.code !==
                                        'FOUNDER' &&
                                    friend.membership_role.code === 'MODERATOR'
                                        
                                "
                            >
                                <div class="ml-2 cursor-pointer">
                                    <vs-button
                                        @click="deleteModerator(friend)"
                                        radius
                                        size="small"
                                        icon="person"
                                        color="danger" 
                                        type="filled"
                                    />
                                </div>
                            </vx-tooltip>
                            
                        </div>
                    </li>
                </ul>
                <vs-button
                    v-if="isStudent"
                    @click="openModalInvite"
                    icon="person_add"
                    class="mt-2 w-full"
                    >{{ $t("invite_student") }}</vs-button
                >

            </vx-card>
    </div>
</template>

<script>
import Profile from "@/widgets/Profile";

export default {
    components:{Profile},
    props:{
        isFounder:{
            type:Boolean,
            default:false,
        },
        isStudent:{
            type:Boolean,
            default:false,
        },
        allRoles:{
            type:Array,
            default:[],
        }
    },

    data() {
        return {
            partisipants: [],
            
        }
    },
    computed: {
        uid() {
            return this.$route.query.uid;
        },
        isUpdate(){
           return this.$store.getters['studclubs/FriendSuggestion'];
        }   
    },
    watch:{
        isUpdate(val){
            if(val){
                this.getPartisipants();
                this.$store.commit('studclubs/changeFriendSuggestion',false);
            }
        }
    },
    created(){
        this.getPartisipants();
    },
    methods: {
           // Получение участников
        async getPartisipants() {
           
            const res = await this.$http(
                `student_clubs/my_student_clubs/${ this.uid }/get_student_club_members/`
            );
            if (res.status === 200) {
                this.partisipants = res.data;
            }
        },

         // Удалить из модератора

        async deleteModerator(item) {
            // console.log("item", item);
            this.$vs.dialog({
                type: "confirm",
                color: "danger",
                title: this.$t("confirm"),
                acceptText: this.$t("yes"),
                cancelText: this.$t("cancel"),
                text:
                    this.$t("delete_moderator_club") +
                    " " +
                    item.student_profile["last_name_" + this.$i18n.locale] +
                    " " +
                    item.student_profile["first_name_" + this.$i18n.locale],
                accept: async () => {
                    const res = await this.$http.put(
                        `student_clubs/my_student_clubs/${ this.uid }/change_member_role/`,
                        {
                            membership_uid: item.uid,
                            student_club_role_uid: this.allRoles[2].uid
                                
                        }
                    );
                    if (res.status === 200) {
                        this.$vs.notify({
                            title: this.$t("succesful"),
                            color: "primary",
                        });
                        this.getPartisipants()
                    }
                },
            });
        },



        // Назначить модератором

        async toModerator(item) {
            // console.log("item", item);
            this.$vs.dialog({
                type: "confirm",
                color: "success",
                title: this.$t("confirm"),
                acceptText: this.$t("yes"),
                cancelText: this.$t("cancel"),
                text:
                    this.$t("change_moderator_club") +
                    " " +
                    item.student_profile["last_name_" + this.$i18n.locale] +
                    " " +
                    item.student_profile["first_name_" + this.$i18n.locale],
                accept: async () => {
                    const res = await this.$http.put(
                        `student_clubs/my_student_clubs/${ this.uid }/change_member_role/`,
                        {
                            membership_uid: item.uid,
                            student_club_role_uid: this.allRoles[1].uid
                                
                        }
                    );
                    if (res.status === 200) {
                        this.$vs.notify({
                            title: this.$t("succesful"),
                            color: "primary",
                        });
                        this.getPartisipants()
                    }
                },
            });
        },


        // Удалить участника из клуба
        async deleteStudent(item) {
            this.$vs.dialog({
                type: "confirm",
                color: "danger",
                title: this.$t("confirm"),
                acceptText: this.$t("yes"),
                cancelText: this.$t("cancel"),
                text:
                    this.$t("delete_student_in_club") +
                    " " +
                    item.student_profile.firstName +
                    " " +
                    item.student_profile.lastName,
                accept: async () => {
                    const res = await this.$http.delete(
                        `student_clubs/my_student_clubs/${ this.uid }/delete_student_club_member/`,
                        {
                            data: { membership_uid: item.uid },
                        }
                    );

                    if (res.status === 200) {
                        this.partisipants = this.partisipants.filter(
                            (el) => el.uid !== item.uid
                        );
                        this.$vs.notify({
                            title: this.$t("succesful"),
                            text: $t("student_deleted"),
                            color: "primary",
                        });
                    }
                },
            });
        },
       

       openModalInvite(){
            this.$emit('openModalInvite');
       }
    },
}
</script>